import IconContainer from '@/components/IconContainer'

export default function IconArrowLeft(props) {
  return (
    <IconContainer
      {...props}
      width="10"
      height="9"
      ariaLabel="Arrow Left Icon"
      fill="currentColor"
    >
      <path d="M9.99996 4.01355C9.99996 4.31875 9.77067 4.57061 9.47431 4.60755L9.39891 4.61222L2.59777 4.61209L4.98626 6.99156C5.20143 7.20587 5.21936 7.54224 5.04005 7.7769L4.98626 7.8382C4.7711 8.05252 4.4334 8.07037 4.19781 7.89178L4.13626 7.8382L0.721451 4.43687C0.50629 4.22256 0.48836 3.88619 0.667661 3.65153L0.721451 3.59023L4.13626 0.188895C4.37098 -0.0448992 4.75154 -0.0448992 4.98626 0.188895C5.20143 0.403207 5.21936 0.739579 5.04005 0.974234L4.98626 1.03554L2.59777 3.41428L9.39891 3.41488C9.73086 3.41488 9.99996 3.68291 9.99996 4.01355Z" />
    </IconContainer>
  )
}
